import script from "./ShingCharge.vue?vue&type=script&setup=true&lang=js"
export * from "./ShingCharge.vue?vue&type=script&setup=true&lang=js"

import "./ShingCharge.vue?vue&type=style&index=0&id=7e740d5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e740d5a"]])

export default __exports__